module.exports = __webpack_public_path__ + "SourceSansPro-LightItalic.f296b36fc652f88b8f54.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-LightItalic.ttf
// module id = ../../../../../src/assets/customfonts/SourceSansPro-LightItalic.ttf
// module chunks = styles